module.exports = __webpack_public_path__ + "static/media/icon-edition.1b1df21b.svg";